module.exports = __webpack_public_path__ + "assets/img/274d18c462beb2eacbed6c226d1bfc25.png";